import React from "react";
import { FilePicker } from "react-file-picker";

export default class ImageSilentInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      base64: this.props.value,
      fileName: this.props.fileName || null,
      fileSize: null,
      isLoadingFile: false,
    };
  }

  // Metodo per resettare il file selezionato
  resetFile() {
    console.log("🗑️ [ImageSilentInput] Reset file");
    this.setState({
      base64: null,
      fileName: null,
      fileSize: null,
      isLoadingFile: false,
    });
  }

  render() {
    return (
      <div style={mainClass}>
        <div style={name}>{this.props.name}</div>

        <FilePicker
          extensions={["jpg", "jpeg", "png", "pdf"]}
          maxSize={80}
          onChange={(file) => {
            console.log("🔵 [ImageSilentInput] File selezionato:", {
              name: file.name,
              size: file.size,
              sizeFormatted: `${(file.size / 1024 / 1024).toFixed(2)} MB`,
              type: file.type,
            });

            const fileSizeMB = (file.size / 1024 / 1024).toFixed(2);

            this.setState({
              fileName: file.name,
              fileSize: fileSizeMB,
              isLoadingFile: true,
            });

            // Passa il file object con informazioni aggiuntive
            const fileInfo = {
              name: file.name,
              size: file.size,
              type: file.type,
            };

            console.log(
              "🔵 [ImageSilentInput] Inizio lettura file come base64..."
            );
            // Nota: per compatibilità con i componenti esistenti, la callback
            // riceve ora 2 argomenti principali: (base64, fileName).
            // Per retrocompatibilità forniamo anche fileInfo come terzo argomento.
            this.getBase64(file, this.props.onChange, fileInfo);
          }}
          onError={(errMsg) => {
            console.error(
              "❌ [ImageSilentInput] Errore selezione file:",
              errMsg
            );

            // Messaggio specifico per file troppo grande
            if (errMsg.includes("size") || errMsg.includes("less than")) {
              alert(
                "⚠️ File troppo grande!\n\nLa dimensione massima consentita è 80 MB.\n\nRiduci le dimensioni del file e riprova."
              );
            } else {
              alert(`Errore nella selezione del file: ${errMsg}`);
            }
          }}
        >
          <button style={name}>Seleziona...</button>
        </FilePicker>

        {this.state.isLoadingFile && !this.state.fileName && (
          <div style={loadingFileStyle}>⏳ Caricamento file in corso...</div>
        )}

        {this.state.fileName && (
          <div style={fileNameStyle}>
            📎 {this.state.fileName}
            {this.state.fileSize && (
              <span
                style={{
                  marginLeft: "10px",
                  color: "#666",
                  fontWeight: "normal",
                }}
              >
                ({this.state.fileSize} MB)
              </span>
            )}
          </div>
        )}
      </div>
    );
  }

  getBase64(file, cb, fileInfo) {
    const startTime = Date.now();
    console.log(
      "🔵 [ImageSilentInput] Inizio conversione base64 per file:",
      fileInfo.name
    );

    let reader = new FileReader();
    const self = this;

    reader.readAsDataURL(file);

    reader.onload = function() {
      const duration = ((Date.now() - startTime) / 1000).toFixed(2);
      console.log(
        `✅ [ImageSilentInput] File convertito in base64 in ${duration}s`,
        {
          fileName: fileInfo.name,
          base64Length: reader.result.length,
          estimatedSizeMB: (
            (reader.result.length * 0.75) /
            1024 /
            1024
          ).toFixed(2),
        }
      );

      self.setState({ isLoadingFile: false });

      // Passa il base64 e, come secondo argomento, il nome del file (string)
      // per evitare che un oggetto venga reso direttamente in JSX (causa React error #31).
      // Manteniamo fileInfo come terzo argomento per retrocompatibilità.
      try {
        cb(reader.result, fileInfo.name, fileInfo);
      } catch (err) {
        console.error(
          "❌ [ImageSilentInput] Errore nella callback onChange:",
          err
        );
      }
    };

    reader.onerror = function(error) {
      console.error("❌ [ImageSilentInput] Errore lettura file:", error);
      self.setState({ isLoadingFile: false });
    };
  }
}

const mainClass = {
  padding: "10px",
};

const name = {
  marginBottom: "10px",
};

const picture = {};

const inputText = {
  width: "300px",
};

const fileNameStyle = {
  marginTop: "10px",
  padding: "8px",
  backgroundColor: "#f0f0f0",
  borderRadius: "4px",
  fontSize: "14px",
  color: "#333",
  fontWeight: "bold",
};

const loadingFileStyle = {
  marginTop: "10px",
  padding: "8px",
  backgroundColor: "#fff3cd",
  borderRadius: "4px",
  fontSize: "14px",
  color: "#856404",
  fontWeight: "bold",
};
